import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Edit, Users } from 'lucide-react'

import { TableRow, TableCell } from '../../ui/table'
import { Badge } from '../../ui/badge'
import { Button } from '../../ui/button'

function AdminFacilityRow({ facility }) {
  const getSubscriptionBadge = () => {
    const status = facility.subscriptionStatus
    if (!status) return <Badge variant="outline">None</Badge>

    const variants = {
      demo: { variant: 'secondary', text: 'Demo' },
      active: { variant: 'default', className: 'bg-green-600', text: 'Active' },
      trialing: { variant: 'default', className: 'bg-blue-600', text: 'Trialing' },
      past_due: { variant: 'destructive', text: 'Past Due' },
      canceled: { variant: 'outline', text: 'Canceled' },
      incomplete: { variant: 'outline', text: 'Incomplete' }
    }

    const config = variants[status] || { variant: 'secondary', text: status }
    return (
      <Badge variant={config.variant} className={config.className}>
        {config.text}
      </Badge>
    )
  }

  return (
    <TableRow>
      <TableCell>
        <Link className="text-purple-600 hover:text-purple-700 font-medium" to={`/facilities/${facility.id}/edit`}>
          {facility.name}
        </Link>
      </TableCell>
      <TableCell className="text-gray-600">{facility.id}</TableCell>
      <TableCell>{getSubscriptionBadge()}</TableCell>
      <TableCell className="text-center font-semibold">{facility.totalStudentsCount || 0}</TableCell>
      <TableCell className="text-center font-semibold">{facility.numberOfStudentsEnrolledThisMonth || 0}</TableCell>
      <TableCell className="text-right">
        <div className="inline-flex items-center gap-2">
          <Link to={`/facilities/${facility.id}/coaches_dashboard`}>
            <Button variant="outline" size="sm" className="inline-flex items-center gap-1.5">
              <Users className="h-3.5 w-3.5" />
              Coach Dashboard
            </Button>
          </Link>
          <Link to={`/facilities/${facility.id}/edit`}>
            <Button variant="outline" size="sm" className="inline-flex items-center gap-1.5">
              <Edit className="h-3.5 w-3.5" />
              Edit
            </Button>
          </Link>
        </div>
      </TableCell>
    </TableRow>
  )
}

AdminFacilityRow.propTypes = {
  facility: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string,
    subscriptionStatus: PropTypes.string,
    totalStudentsCount: PropTypes.number,
    numberOfStudentsEnrolledThisMonth: PropTypes.number
  }).isRequired
}

export default AdminFacilityRow
